export const BUISNESS_FUNCTION_PAGE_SIZE = 20;

export const BUISNESS_FUNCTION_STATES = {
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
} as const;

export const BUISNESS_FUNCTION_STATE_LABELS = {
  CREATED: 'Created',
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
} as const;
